/**
 * Leaderboard client configuration.
 *
 * The API is served from the *same origin* as the game, behind CloudFront at
 * `/api/*`. That is deliberate: it keeps the site's Content-Security-Policy at
 * `connect-src 'self'`, and it means there is no CORS preflight on the hot path
 * (the submission that happens the moment you sit down).
 */

export const LEADERBOARD = {
  /** Same-origin path prefix. Overridable in dev via VITE_LANIAAMU_API. */
  baseUrl: '/api/v1',
  /** How many rows the board shows. */
  topCount: 10,
  /** Give up rather than make the player stare at a spinner after a run. */
  requestTimeoutMs: 8000,
  /** A run ticket is fetched at READY; this is how long the server honours it. */
  ticketLifetimeMs: 30 * 60 * 1000,
} as const;

/** Where the chosen display name lives between sessions. */
export const PLAYER_NAME_STORAGE_KEY = 'laniaamu.name';

/** Longest name the board will show. Enforced again on the server. */
export const MAX_NAME_LENGTH = 18;
